// extracted by mini-css-extract-plugin
export default {"Auth":"Auth_Auth__gETeH","AuthForm":"Auth_AuthForm__9WSve"};